import { ProductFilter } from 'containers/RetailMomo/Products/ProductFilter';
import { SmartCampaignConfig } from 'core/configuration/SmartCampaignConfig';
import { Product } from 'core/product/Product';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type ProductListDataContextType = {
  brandContext?: string;
  liveProducts?: Product[];
  selectedProducts: Product[];
  selectedAutoProducts: Product[];
  smartCampaignConfig?: SmartCampaignConfig;
  changeSelectedProducts: (
    fn: (selectedProducts: Product[]) => Product[],
  ) => void;
  changeSelectedAutoProducts: (
    fn: (selectedAutoProducts: Product[]) => Product[],
  ) => void;
  handleSetProductList: (liveProducts: Product[]) => void;
  handleFilterChanged: (filter: ProductFilter) => void;
  resetProductStore: () => void;
};

export const useProductStore = create<ProductListDataContextType>()(
  devtools(
    (set) => ({
      brandContext: '',
      liveProducts: [],
      selectedProducts: [],
      selectedAutoProducts: [],
      smartCampaignConfig: undefined,
      changeSelectedProducts: (fn) =>
        set((state) => ({ selectedProducts: fn(state.selectedProducts) })),
      changeSelectedAutoProducts: (fn) =>
        set((state) => ({
          selectedAutoProducts: fn(state.selectedAutoProducts ?? []),
        })),
      handleSetProductList: (liveProducts) => {
        set({
          liveProducts,
        });
      },
      handleFilterChanged: () => {
        // This is intentionally left blank
      },
      resetProductStore: () => {
        set({
          brandContext: '',
          selectedProducts: [],
          selectedAutoProducts: [],
          smartCampaignConfig: undefined,
        });
      },
    }),
    { name: 'Product Store' },
  ),
);
